/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Často kupováno s tímto produktem`
};

const da_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Ofte købt sammen med dette produkt`
};

const de_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Häufig zusammen gekauft`
};

const en_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Frequently bought together`
};

const es_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Frecuentemente comprados con este producto`
};

const fr_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Fréquemment achetés avec ce produit`
};

const hu_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Gyakran vásárolják ezzel a termékkel`
};

const it_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Acquistati frequentemente con questo prodotto`
};

const nl_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Vaak samen gekocht met dit product`
};

const pl_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Często kupowane z tym produktem`
};

const pt_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Frequentemente comprados com este produto`
};

const sv_complementary_products = /** @type {(inputs: {}) => string} */ () => {
	return `Köps ofta tillsammans med denna produkt`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const complementary_products = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.complementary_products(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("complementary_products", locale)
	if (locale === "cs") return cs_complementary_products(inputs)
	if (locale === "da") return da_complementary_products(inputs)
	if (locale === "de") return de_complementary_products(inputs)
	if (locale === "en") return en_complementary_products(inputs)
	if (locale === "es") return es_complementary_products(inputs)
	if (locale === "fr") return fr_complementary_products(inputs)
	if (locale === "hu") return hu_complementary_products(inputs)
	if (locale === "it") return it_complementary_products(inputs)
	if (locale === "nl") return nl_complementary_products(inputs)
	if (locale === "pl") return pl_complementary_products(inputs)
	if (locale === "pt") return pt_complementary_products(inputs)
	return sv_complementary_products(inputs)
};